import { makeStyles, tokens } from '@fluentui/react-components';
import { Bar, BarChart, Cell, ResponsiveContainer, Tooltip as RechartsTooltip, XAxis, YAxis } from 'recharts';

import DashboardChartPanel from './DashboardChartPanel';
import type { TDashboardStatusChartDatum } from '../types/dashboard.types';

const useStyles = makeStyles({
  chart: {
    width: '100%',
    height: '250px',
  },
});

type TProps = {
  data: TDashboardStatusChartDatum[];
};

const DashboardStatusDistributionChart = ({ data }: TProps) => {
  const classes = useStyles();

  return (
    <DashboardChartPanel title="Status counts">
      <div className={classes.chart}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ top: 4, right: 28, bottom: 4, left: 8 }}>
            <XAxis type="number" allowDecimals={false} tickLine={false} axisLine={false} />
            <YAxis type="category" dataKey="label" width={124} tickLine={false} axisLine={false} />
            <RechartsTooltip
              cursor={{ fill: tokens.colorNeutralBackground3 }}
              formatter={(value) => [value, 'Items']}
            />
            <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={20}>
              {data.map((entry) => (
                <Cell key={entry.key} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </DashboardChartPanel>
  );
};

export default DashboardStatusDistributionChart;
